import { render, staticRenderFns } from "./route-discrepancy-comp.vue?vue&type=template&id=435fc554&"
import script from "./route-discrepancy-comp.vue?vue&type=script&lang=js&"
export * from "./route-discrepancy-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports